{
    "smartTasks": {
        "generate": {
            "focusApp": {
                "title": "Concentrez-vous sur l'application",
                "description": "Assurez-vous de sélectionner l'application où vous souhaitez que le texte généré apparaisse. Vous pourrez générer le texte à cet endroit en toute simplicité en cliquant sur « Générer »."
            }
        },
        "rewrite": {
            "focusApp": {
                "title": "Concentrez-vous sur l'application",
                "description": "Assurez-vous de sélectionner l'application où vous souhaitez que le texte réécrit apparaisse. Vous pourrez générer facilement le texte à cet endroit en cliquant sur « Générer »."
            }
        }
    },
    "customControls": {
        "tourLabel": "Contrôles globaux et des appareils toujours disponibles",
        "rowDescription": "Les commandes globales et celles de l'appareil sont toujours disponibles si votre microphone est activé, quelle que soit l'application utilisée. Vous pouvez utiliser ces commandes pour interagir avec votre appareil sans avoir à créer de nouvelles commandes. Elles contiennent des commandes utiles comme changer de commande ou d'application, générer du texte, mettre votre microphone en pause, et bien plus encore."
    },
    "profile": {
        "switch": {
            "title": "Commandes de l'application Switch",
            "description": "Les commandes de votre application peuvent basculer automatiquement en fonction de l'application que vous utilisez, ou vous pouvez les modifier manuellement ici à tout moment."
        }
    },
    "dictation": {
        "tourLabel": "Dictée",
        "learn": "Apprenez à utiliser le mode dictée pour convertir votre discours en texte en mains libres.",
        "welcome": {
            "title": "Dictée",
            "description": "La dictée vous permet de parler naturellement et de saisir vos mots pendant que vous parlez. C'est comme avoir un assistant personnel qui saisit tout ce que vous dites."
        },
        "microphone": {
            "title": "Allumez votre microphone",
            "description": "Tout d'abord, activez votre microphone. Cliquez sur l'icône « Microphone » dans le panneau Cephable."
        },
        "activate": {
            "title": "Démarrer le mode dictée",
            "description": "La voix démarre en mode commande. Pour lancer la dictée, dites « Démarrer la dictée » ou cliquez sur le bouton « Dictée ». Activons maintenant le mode dictée."
        },
        "focus": {
            "title": "Se concentrer sur un champ de texte ou un document",
            "description": "La dictée est plus efficace lorsque vous vous concentrez sur un champ de texte ou un document. Cliquez sur le champ de texte ou le document où vous souhaitez dicter."
        },
        "speaking": {
            "title": "Commencez à parler",
            "description": "Vous pouvez maintenant commencer à parler. Tout ce que vous direz sera saisi dans le champ de texte ou le document sur lequel vous vous êtes concentré. Essayez de dire quelque chose comme : « Bonjour, ceci est un test du mode dictée. »"
        },
        "pauseResume": {
            "title": "Pause de la dictée",
            "description": "Besoin d'une pause sans désactiver la dictée ? Dites simplement « Suspendre la dictée ». Vous pouvez la reprendre à tout moment avec « Démarrer la dictée ». Vous pouvez personnaliser davantage cette option grâce aux commandes globales et aux commandes de l'appareil toujours actives."
        },
        "stop": {
            "title": "Arrêter la dictée",
            "description": "Besoin de revenir aux commandes de votre application ? Dites simplement « Arrêter la dictée ». Cela arrêtera le mode dictée et vous ramènera au mode commande. Vous pouvez reprendre à tout moment en cliquant à nouveau sur « Démarrer la dictée »."
        },
        "complete": {
            "description": "Et voilà ! Vous pouvez désormais dicter, mettre en pause, reprendre et passer du mode dictée au mode commande. La dictée est un outil puissant pour la saisie mains libres. Utilisez-la pour rédiger des e-mails, des documents ou tout ce que vous devez saisir à voix haute."
        }
    },
    "microphone": {
        "tourLabel": "Commandes vocales",
        "learn": "Découvrez comment utiliser votre voix pour contrôler n’importe quelle application et utiliser la dictée pour taper ce que vous dites.",
        "rowDescription": "Lorsque le microphone est désactivé, nous n'entendons pas vos commandes vocales. Cependant, si vous l'activez, vous pourrez utiliser les commandes globales pour mettre en pause, démarrer, etc. Allumons-le.",
        "tryOpen": {
            "title": "Essayez de dire « Ouvrir Spotify » ou « Ouvrir Word »"
        },
        "finishedCommands": {
            "title": "Excellent ! Vous avez appris les bases des commandes vocales.",
            "description": "Vous pouvez toujours consulter la visite depuis la page d'assistance. L'étape suivante consiste à découvrir la dictée. Vous pouvez commencer la visite depuis la page d'assistance."
        }
    },
    "tour": {
        "startTour": "Démarrer la visite",
        "finishTour": "Terminer la tournée",
        "statusDialog": "Veuillez consulter le panneau pour plus d'informations.",
        "step": "Étape {{step}} sur {{total}}",
        "skipTour": "Skip Tour"
    },
    "onboarding": {
        "overview": "Aperçu",
        "learn": "Découvrez les fonctionnalités de Cephable et comment les utiliser.",
        "start": "On dirait que vous ne faites que commencer. Voici quelques pistes pour vous aider.",
        "dashboard": {
            "title": "Espace de travail Cephable",
            "description": "L'espace de travail Cephable centralise la gestion de votre appareil, des commandes d'applications et des paramètres. Vous pouvez y personnaliser votre expérience, consulter les commandes actives et accéder à toutes les fonctionnalités de Cephable."
        },
        "step1": {
            "title": "Bienvenue chez Cephable",
            "description": "Cephable est votre IA personnelle : conçue pour des actions rapides, des commandes vocales, la génération de contenu et une automatisation intelligente de vos outils. Des commandes prêtes à l'emploi. Aucun traitement cloud. Juste une productivité qui vous accompagne."
        },
        "finish": {
            "continueToApp": "Continuer vers le tableau de bord Cephable",
            "keepExploring": "Continuez à explorer"
        },
        "useCaseSlider": {
            "context": "J'aimerais utiliser",
            "control": "contrôler"
        }
    },
    "support": {
        "description": "Vous pouvez visiter notre centre d'assistance pour plus d'informations sur l'utilisation de Cephable, notamment des visites guidées, des guides étape par étape, des didacticiels et des vidéos.",
        "title": "Soutien"
    },
    "editingVideos": {
        "tourLabel": "Concentrez-vous sur l'histoire, pas sur les clics fastidieux du montage vidéo",
        "learn": "Apprenez à utiliser les commandes vocales et la dictée pour monter vos vidéos plus rapidement et éliminez la charge cognitive liée à la mémorisation des boutons sur lesquels cliquer pendant le montage.",
        "tryOpen": {
            "title": "Essayez de dire « Ouvrir CapCut » ou « Ouvrir iMovie »."
        },
        "complete": {
            "description": "Vous savez désormais comment utiliser les commandes vocales et les actions rapides pour lire, mettre en pause, passer à la piste suivante et régler le volume dans vos applications de montage vidéo préférées. Explorez d'autres commandes ou personnalisez vos propres actions rapides pour un contrôle vidéo encore plus fluide."
        }
    },
    "congrats": "Bravo!",
    "fpsGamePlay": {
        "tourLabel": "Jouez à des jeux FPS avec des commandes vocales",
        "learn": "Apprenez à utiliser les commandes vocales et les actions rapides pour jouer à des jeux FPS.",
        "tryOpen": {
            "title": "Essayez de dire « Ouvrir Valorant » ou « Ouvrir Battlefield »"
        },
        "complete": {
            "description": "Vous savez maintenant utiliser les commandes vocales et les actions rapides pour déplacer, arrêter et contrôler votre personnage dans les jeux FPS. Explorez d'autres commandes ou personnalisez vos actions rapides pour un gameplay encore plus fluide et rapide."
        }
    },
    "redo": "Refaire l'intégration",
    "title": "Découvrez Cephable",
    "description": "Découvrez Cephable, votre assistant IA personnel et partagez votre intérêt pour les cas d'utilisation personnalisés.",
    "panel": {
        "description": "Voici le panneau de contrôle principal. Toujours visible, il vous permet de contrôler vos applications à la voix, et bien plus encore. Commençons par le microphone."
    },
    "controlExpanded": {
        "tourLabel": "Contrôle",
        "description": "Les commandes d'application sont des ensembles de commandes configurables que vous pouvez utiliser dans une application donnée. Cette section présente toutes les commandes disponibles : commandes vocales, interactions tactiles, saisie au clavier, etc."
    },
    "submit": {
        "title": "Soumettre",
        "description": "Le contenu sera affiché à l'endroit où se trouve le curseur."
    },
    "tryOpen": {
        "description": "`Open` est une commande globale qui ouvre l'application spécifiée et lui donne le focus. Si la commutation automatique des commandes est activée, elle basculera également vers les commandes les mieux adaptées à l'application utilisée."
    },
    "modeSelector": {
        "title": "Sélectionner le mode",
        "description": "Si cette option est disponible, vous pouvez sélectionner le mode de fonctionnement. Utilisez « Contrôle » pour l’application par laquelle vous souhaitez envoyer des commandes, « Créer » pour la génération de contenu textuel (résumé, réécriture, traduction, etc.) et « Automatiser » pour les flux de travail sur ordinateur ou entre applications."
    },
    "contextSelector": {
        "title": "Sélectionner le contexte",
        "description": "Si possible, vous pouvez sélectionner le contexte dans lequel je vais intervenir. Par exemple, je peux utiliser votre presse-papiers ou le texte sélectionné, et vous pouvez également joindre des fichiers ou des dossiers sur lesquels vous souhaitez que je travaille."
    },
    "panelInput": {
        "title": "Que voulez-vous que je fasse ?",
        "description": "Vous pouvez me donner des ordres, taper ou dicter ce que vous voulez que je fasse."
    },
    "figma": {
        "tourLabel": "Commandes vocales pour Figma et Canva",
        "learn": "Découvrez comment utiliser les commandes vocales, la souris vocale, la dictée et la génération de contenu par IA de Controls pour améliorer votre flux de travail de conception.",
        "complete": {
            "description": "Vous savez désormais comment contrôler et créer des designs pour optimiser votre flux de travail. Explorez d'autres commandes pour un contrôle encore plus fluide de vos créations."
        },
        "tryOpen": {
            "title": "Essayez de dire « Ouvrir Figma » ou « Ouvrir Canva »."
        }
    },
    "voiceMouse": {
        "title": "Souris vocale",
        "description": "Pour cliquer sur les boutons par leur nom, vous pouvez utiliser la souris vocale. Pour cela, dites « appuyer sur enregistrer » ou « aller dans les paramètres »."
    },
    "documentSummary": {
        "tourLabel": "Résumés des équipes de draft tirés de rapports confidentiels",
        "learn": "Automatisez la lecture des rapports de service, identifiez les personnes à informer et rédigez un e-mail, le tout sur votre appareil, pour que vos données confidentielles restent privées.",
        "congrats": {
            "description": "Vous savez désormais comment utiliser les flux de travail d'IA pour lire des documents confidentiels et rédiger un courriel de synthèse à votre équipe, le tout sans que vos données ne quittent votre appareil."
        }
    },
    "extensions": {
        "tourLabel": "Extensions",
        "rowDescription": "Étendez les possibilités de Cephable avec davantage de moyens de contrôler votre appareil : commandes de la caméra pour les mouvements du visage et de la tête, compatibilité avec les manettes de jeu, etc. Activez les options souhaitées ici."
    },
    "developerBuildTests": {
        "tourLabel": "Automatisez les processus de compilation et de test grâce aux flux de travail d'IA",
        "learn": "Cephable peut exécuter des tâches terminales en plusieurs étapes — comme la compilation de votre projet et l'exécution de ses tests — entièrement sur l'appareil, en arrière-plan, pendant que vous continuez à travailler.",
        "complete": {
            "description": "Vous savez désormais comment exécuter des workflows d'IA embarqués pour des tâches de compilation et de test en plusieurs étapes, répondre aux demandes d'autorisation et itérer sur les résultats. Essayez d'automatiser une autre tâche de développement répétitive."
        }
    },
    "classroomStudyTools": {
        "tourLabel": "Transformer les notes de cours et les articles en outils d'étude et en matériel pédagogique",
        "learn": "Cephable accompagne les enseignants et les élèves grâce à la dictée, aux outils de création intégrés et à l'automatisation, directement dans les applications que vous utilisez déjà, en préservant la confidentialité de toutes vos données sur votre appareil.",
        "complete": {
            "description": "Vous savez désormais comment dicter directement dans vos documents, générer de nouveaux supports d'étude à partir de vos notes et utiliser Automate pour créer des devoirs complets en arrière-plan, le tout sur votre appareil."
        }
    },
    "engineeringFlows": {
        "tourLabel": "Commandes vocales et automatisations IA pour les développeurs",
        "learn": "Découvrez comment accélérer votre flux de travail d'ingénierie grâce aux commandes de développement vocales, à la réécriture par IA utilisant votre propre code comme contexte et aux flux de travail d'IA en arrière-plan, le tout exécuté sur l'appareil.",
        "tryOpen": {
            "title": "Essayez de dire « Ouvrir Visual Studio Code »."
        },
        "complete": {
            "description": "Vous savez désormais comment utiliser les commandes de développement vocales, la réécriture par IA avec votre propre code comme contexte et les flux de travail d'IA en arrière-plan pour accélérer votre flux d'ingénierie."
        }
    },
    "meetingNotesToFiles": {
        "tourLabel": "Transformer les notes de réunion en fichiers exploitables",
        "learn": "Cephable vous permet de découper vos notes de réunion en fichiers plus petits et exploitables que vous pouvez traiter à votre rythme, directement sur votre appareil.",
        "complete": {
            "description": "Vous savez désormais comment utiliser les flux de travail d'IA pour diviser les notes de réunion en fichiers exploitables plus petits et reprendre la conversation à tout moment grâce à l'historique d'IA."
        }
    },
    "notesToPresentation": {
        "tourLabel": "Résumez vos notes confidentielles et créez une présentation, le tout sur votre appareil.",
        "learn": "Cephable peut synthétiser vos rapports et notes confidentiels, puis utiliser des flux de travail d'IA pour traiter l'ensemble d'un dossier de fichiers, et même créer une présentation à partir des résultats. Le tout s'exécute directement sur votre appareil.",
        "complete": {
            "description": "Vous savez désormais comment résumer des documents confidentiels, générer des résumés par lots d'un dossier entier grâce aux flux de travail d'IA et transformer les résultats en une présentation, le tout sans que vos données ne quittent votre appareil."
        }
    },
    "organizeDownloads": {
        "tourLabel": "Organisez vos fichiers, faites le ménage et retrouvez ce que vous avez perdu — grâce aux flux de travail d'IA",
        "learn": "Automate peut gérer des tâches de gestion de fichiers en plusieurs étapes (copie, suppression et recherche de fichiers) directement à partir d'une simple invite de commande.",
        "complete": {
            "description": "Vous savez désormais comment utiliser les flux de travail d'IA pour organiser les fichiers, les nettoyer en toute sécurité grâce à des vérifications d'autorisation et retrouver les fichiers dont vous ne vous souvenez plus de l'emplacement."
        }
    },
    "outlookEmailProductivity": {
        "tourLabel": "Accélérez la gestion de vos e-mails dans Outlook grâce à la dictée, aux actions rapides et à l'IA.",
        "learn": "Cephable Plus et Professional incluent des outils intelligents de dictée et de création pour générer et modifier du contenu ; utilisez-les directement dans Outlook pour répondre et rédiger des e-mails plus rapidement.",
        "complete": {
            "description": "Vous savez désormais comment répondre aux e-mails par dictée, utiliser vos propres actions Quick Type et utiliser les fonctions Résumer et Générer pour rédiger et peaufiner le contenu des e-mails, le tout sur votre appareil."
        }
    },
    "customizingGameControls": {
        "tourLabel": "Jouez à des jeux RPG avec commandes vocales",
        "learn": "Apprenez à utiliser les commandes vocales et les actions rapides pour jouer aux jeux de rôle.",
        "tryOpen": {
            "title": "Essayez de dire « Ouvrir Minecraft »."
        },
        "complete": {
            "description": "Vous savez désormais utiliser les commandes vocales et les raccourcis pour déplacer, arrêter et contrôler votre personnage dans les jeux de rôle. Explorez d'autres commandes ou personnalisez vos propres raccourcis pour une expérience de jeu encore plus fluide et rapide."
        }
    },
    "voiceToTextSocialMedia": {
        "tourLabel": "Personnalisation vocale pour LinkedIn, Slack et Discord",
        "learn": "Utilisez la dictée intelligente pour rédiger un message naturellement, puis réécrivez-le pour en ajuster le ton — cela fonctionne de la même manière sur LinkedIn, Slack, Discord et bien plus encore.",
        "complete": {
            "description": "Vous savez désormais comment dicter un message et le peaufiner avec la fonction de réécriture, sur LinkedIn, Slack, Discord et bien plus encore."
        }
    },
    "aiDocumentTranslation": {
        "tourLabel": "Traduisez des documents dans n'importe quelle langue, directement sur votre appareil.",
        "learn": "Cephable peut traduire un document dans une langue à la fois, ou utiliser des flux de travail d'IA pour le traduire simultanément dans plusieurs langues, le tout en local.",
        "complete": {
            "description": "Vous savez désormais comment traduire un document dans une seule langue par dictée, ou dans plusieurs langues simultanément grâce aux flux de travail d'IA, le tout directement sur votre appareil."
        }
    },
    "excelAiAutomation": {
        "tourLabel": "Analysez vos feuilles de calcul grâce à une IA privée et embarquée.",
        "learn": "Cephable peut analyser vos fichiers Excel, répondre aux questions concernant les chiffres et aller plus loin, le tout sans que vos données ne quittent votre appareil.",
        "complete": {
            "description": "Vous savez désormais comment utiliser les flux de travail d'IA pour analyser vos feuilles de calcul, approfondir vos recherches grâce à des suivis et enregistrer un résumé, le tout directement sur votre appareil."
        }
    },
    "handsFreeComputerControl": {
        "tourLabel": "Contrôlez votre ordinateur par la voix et la caméra",
        "learn": "Cephable vous permet de contrôler votre ordinateur en mode mains libres grâce aux commandes vocales, à la souris vocale et aux commandes faciales et de tête basées sur la caméra.",
        "tryOpenWord": {
            "title": "Essayez de dire « Open Word »."
        },
        "openExtensions": {
            "title": "Ouvrez l'onglet Extensions",
            "description": "Pour activer les commandes de la caméra, ouvrez l'onglet Extensions dans la fenêtre principale."
        },
        "turnOnCamera": {
            "title": "Activer les commandes de la caméra",
            "description": "Activez la caméra. Une icône de caméra apparaît à côté de l'icône du microphone, et une nouvelle section Caméra apparaît dans les Paramètres."
        },
        "cameraInPanel": {
            "title": "Commandes de la caméra dans votre panneau",
            "description": "Maintenant que les commandes de la caméra sont activées, le bouton de basculement de la caméra apparaît également dans votre panneau Cephable ; Cephable l’active pour vous ici."
        },
        "openCameraSettings": {
            "title": "Ouvrir les paramètres de l'appareil photo",
            "description": "Ouvrez les paramètres de l'appareil photo pour ajuster le fonctionnement des commandes de la tête et du visage."
        },
        "chooseHeadMouseMode": {
            "title": "Choisissez un mode Tête-Souris",
            "description": "Choisissez comment les mouvements de votre tête contrôlent votre souris : Glissement stable, Accélération ou Glissement dynamique."
        },
        "complete": {
            "description": "Vous savez désormais comment contrôler votre ordinateur par la voix, la souris vocale et les commandes faciales et de la tête via la caméra. Explorez les paramètres de la caméra pour personnaliser vos commandes."
        }
    },
    "handsFreeTypingDocumentCreation": {
        "tourLabel": "Créez et modifiez des documents en mode mains libres",
        "learn": "Utilisez conjointement les fonctions Générer, Réécrire et les commandes vocales pour créer et modifier un document (comme une facture) presque entièrement en mode mains libres.",
        "complete": {
            "description": "Vous savez désormais comment générer, réécrire et modifier un document presque entièrement en mode mains libres grâce aux fonctions Générer, Réécrire et aux commandes vocales."
        }
    },
    "webResearchCreateHtml": {
        "tourLabel": "Faites des recherches sur le Web et créez un site web à partir de ces recherches, le tout sur votre appareil.",
        "learn": "Cephable peut parcourir et analyser les sites web concurrents, puis utiliser les informations trouvées pour générer un nouveau site HTML pour vous — entièrement sur votre appareil, afin que vos recherches restent privées.",
        "complete": {
            "description": "Vous savez désormais comment utiliser les flux de travail d'IA pour analyser les sites web concurrents et générer un nouveau site HTML à partir des résultats obtenus, le tout sans que vos données ne quittent votre appareil."
        }
    },
    "webResearchSummarize": {
        "tourLabel": "Recherchez les réglementations et résumez les résultats — le tout sur votre appareil",
        "learn": "Cephable peut parcourir le web pour rechercher des changements tels que les nouvelles lois sur la protection des données, puis résumer ses découvertes en un document exploitable par votre équipe — le tout sur l'appareil, garantissant ainsi la confidentialité de vos recherches.",
        "complete": {
            "description": "Vous savez désormais comment utiliser les flux de travail d'IA pour étudier les changements réglementaires, approfondir leur mise en œuvre et rédiger les conclusions sous forme d'e-mail sur lequel votre équipe peut travailler, le tout sans que vos données ne quittent votre appareil."
        }
    },
    "stopListening": {
        "title": "Essayez de dire « Arrête d'écouter ».",
        "description": "Cela met votre microphone en pause sans le couper complètement. Dites de nouveau « Écouter » lorsque vous serez prêt."
    }
}
